import { render, staticRenderFns } from "./SelecionarFreteCliente.vue?vue&type=template&id=ce9d68da&"
import script from "./SelecionarFreteCliente.vue?vue&type=script&lang=js&"
export * from "./SelecionarFreteCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports